class Vote {
	constructor(elem) {
		this.voteWrap = elem;
		this.voteBtn = elem.children('.vote__item');
	}

	init() {
		let _this = this;
		this.voteBtn.click(function() {
			let num = +$(this).children('span').text();
			$(this).children('span').text(num + 1);
			$(this).addClass('selected');
			_this.voteWrap.addClass('vote--disabled');
		});
	}
}

export {Vote}

$(document).on('load', () => {
	if ($('[data-vote]').length > 0) {
		let votes = [];
		$('[data-vote]').each(function(i) {
			votes[i] = new Vote($(this));
			votes[i].init();
		});
	}
});
